import React, { ButtonHTMLAttributes } from 'react';

import { Container } from './styles';

type IconProps = ButtonHTMLAttributes<HTMLButtonElement>;

const Icon: React.FC<IconProps> = ({ children, ...rest }) => (
  <Container type="button" {...rest}>
    {children}
  </Container>
);

export default Icon;
